module.exports = __webpack_public_path__ + "static/media/ic_arrow_down.38c650d7.svg";